import { SxProps, Theme } from '@mui/material';
import { commonStyles } from '~/theme/styles/commonStyles.ts';

export const styles: Record<string, SxProps<Theme>> = {
  modalContainer: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as Object),
    zIndex: 2,
    width: '80%',
    overflowX: 'hidden',
  }),
  modalContent: (theme: Theme) => ({
    color: theme.palette.text.primary,
    textAlign: 'justify',
  }),
};
